export default "__VITE_ASSET__BfQg5GB9__"